import { render, staticRenderFns } from "./InnerDocumentList.vue?vue&type=template&id=0c816b52&"
import script from "./InnerDocumentList.vue?vue&type=script&lang=js&"
export * from "./InnerDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports